import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconDownload: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#00795B',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.64665 9.02002C5.45131 8.82469 5.45131 8.508 5.64665 8.31266C5.84198 8.11733 6.15867 8.11733 6.354 8.31266L7.50065 9.45935V2C7.50065 1.724 7.72465 1.5 8.00065 1.5C8.27665 1.5 8.50065 1.724 8.50065 2V9.45935L9.6473 8.31266C9.84263 8.11733 10.1593 8.11733 10.3547 8.31266C10.55 8.508 10.55 8.82469 10.3547 9.02002L8.35466 11.02C8.30866 11.066 8.25339 11.1027 8.19206 11.128C8.13072 11.1533 8.06598 11.1667 8.00065 11.1667C7.93532 11.1667 7.87074 11.1533 7.80941 11.128C7.74807 11.1027 7.69265 11.066 7.64665 11.02L5.64665 9.02002ZM12 6.16667C11.724 6.16667 11.5 6.39067 11.5 6.66667C11.5 6.94267 11.724 7.16667 12 7.16667C13.0513 7.16667 13.5 7.61533 13.5 8.66667V12C13.5 13.0513 13.0513 13.5 12 13.5H4C2.94867 13.5 2.5 13.0513 2.5 12V8.66667C2.5 7.61533 2.94867 7.16667 4 7.16667C4.276 7.16667 4.5 6.94267 4.5 6.66667C4.5 6.39067 4.276 6.16667 4 6.16667C2.388 6.16667 1.5 7.05467 1.5 8.66667V12C1.5 13.612 2.388 14.5 4 14.5H12C13.612 14.5 14.5 13.612 14.5 12V8.66667C14.5 7.05467 13.612 6.16667 12 6.16667Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconDownload;
